import React from 'react';

const Email = ({ emailAddress, displayText }) => {
  return (
    <a className="mail-to" href="mailto:{emailAddress}">{displayText ? displayText : emailAddress}</a>
  );
}

export default Email;